export default __webpack_public_path__ + "static/media/fox_new.6cc6cab2.svg";